import React, {useEffect, useState} from "react";
import useToastNotify from "../../../hook/useToastNotify";
import {useHistory, useLocation} from "react-router-dom";
import {IPagesProps} from "../../../contracts/pages";
import httpClient from "../../../services/httpClient";
import {teachersApi} from "../../../constans/apiUrls";
import TableTr from "../../Elements/Table/TableTr";
import TableTd from "../../Elements/Table/TableTd";
import TableTdContent from "../../Elements/Table/TableTdContent";
import Badge from "../../Elements/Badge";
import {badgeType} from "../../../constans/enumTypes";
import MenuDrop from "../../Elements/MenuDrop";
import MenuDropItem from "../../Elements/MenuDrop/MenuDropItem";
import {FiEdit, FiVideo} from "react-icons/fi";
import {MdOutlineAttachment, MdOutlineLoop} from "react-icons/md";
import Table from "../../Elements/Table";
import TableEmpty from "../../Elements/Table/TableEmpty";
import MyPagination from "../../Elements/MyPagination";
import useQuery from "../../../hook/useQuery";
import {isNotEmpty} from "../../../helpers/functions";
import {ITeacherListData} from "../../../contracts/data/teacher";
import {TfiWorld} from "react-icons/tfi";

const TeachersList:React.FC<IPagesProps> = () => {
    const {toastNotify} = useToastNotify();
    const history = useHistory()
    const location = useLocation()
    const queryParams = useQuery()
    const [data, setData] = useState<Array<ITeacherListData>>([]);
    const [page, setPage] = useState<number>(isNotEmpty(queryParams.get('page_num')) ? parseInt(queryParams.get('page_num')!) : 1);
    const [countItems, setCountItems] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(true);
    const [reload, setReload] = useState<boolean>(false);

    const titleHeadTable: Array<string> = ['#', 'نام خانوادگی', 'نام', 'اولویت', 'وضعیت', 'عملیات']

    const fetchItemsData = async (search: string | null | undefined = "") => {
        await httpClient().get(`${teachersApi.list}?page=${page}`, {params: {search}})
            .then(response => {
                if(response.status === 200){
                    setCountItems(response.data.count)
                    setData(response.data.results)
                }
            })
            .catch(error => toastNotify('error', 'مشکلی در دریافت لیست آیتم ها وجود دارد'))
            .finally(() => setLoading(false))
    }

    const handleSearchItems = async (search: string | null | undefined = "") => {
        setLoading(true)
        setPage(1)
        fetchItemsData(search)
    }

    const handleChangeStatusItem = async (id: number, index: number) => {
        await httpClient().put(teachersApi.status, {teacher: id})
            .then(response => {
                if(response.status === 200){
                    data[index].is_active = !data[index].is_active
                    setReload(true)
                }
            })
            .catch(error => {console.log(error)})
    }

    useEffect(() => {
        fetchItemsData()
    }, [page])

    useEffect(() => {
        if (reload) {
            setReload(false)
        }
    }, [reload])

    const itemsTableRows = data.map((item, index) =>
        <TableTr key={`table-row${index}`}>
            <TableTd><TableTdContent content={`${index + 1}`}/></TableTd>
            <TableTd><TableTdContent content={item?.last_name} hasImage={true} image={item?.avatar_url} /></TableTd>
            <TableTd><TableTdContent content={item?.first_name} /></TableTd>
            <TableTd><TableTdContent content={item?.priority} /></TableTd>
            <TableTd>
                <Badge title={item?.is_active ? "فعال" : "غیرفعال"}
                       typeBadge={item?.is_active ? badgeType.success : badgeType.error}/>
            </TableTd>
            <TableTd>
                <MenuDrop>
                    <MenuDropItem title={"ویرایش"} icon={<FiEdit/>} isLinkBtn urlLinkProps={{
                        pathname: '/dashboard/teachers/edit',
                        search: `?id=${item?.id}`,
                        state: {page: location.pathname, page_num: page}
                    }}/>
                    <MenuDropItem title={"شبکه های اجتماعی"} icon={<TfiWorld/>} isLinkBtn urlLinkProps={{
                        pathname: '/dashboard/teachers/social-networks',
                        search: `?id=${item?.id}&name=${item?.first_name + " " + item?.last_name}`,
                        state: {page: location.pathname, page_num: page}
                    }}/>
                    <MenuDropItem title={"پیوست اطلاعات"} icon={<MdOutlineAttachment/>} isLinkBtn urlLinkProps={{
                        pathname: '/dashboard/teachers/attachments',
                        search: `?id=${item?.id}&name=${item?.first_name + " " + item?.last_name}`,
                        state: {page: location.pathname, page_num: page}
                    }}/>
                    <MenuDropItem title={"محصولات ویدیویی"} icon={<FiVideo/>} isLinkBtn urlLinkProps={{
                        pathname: '/dashboard/teachers/videos-products-list',
                        search: `?id=${item?.id}&name=${item?.first_name + " " + item?.last_name}`,
                        state: {page: location.pathname, page_num: page}
                    }}/>
                    <MenuDropItem title={"تغییر وضعیت"} icon={<MdOutlineLoop/>}
                                  handleOnSubmit={() => handleChangeStatusItem(item?.id, index)}/>
                </MenuDrop>
            </TableTd>
        </TableTr>
    )

    return(
        <React.Fragment>
            <Table isLoading={loading} title={'لیست اساتید'} subTitle={`تعداد کل: ${countItems}`}
                   titlesTable={titleHeadTable} isSearch={true} handleSearch={handleSearchItems}>
                {itemsTableRows.length > 0 ? itemsTableRows :
                    <TableEmpty colSpan={titleHeadTable.length} message={"استادی یافت نشد"}/>}
            </Table>
            <div className={"text-right"}>
                <MyPagination countItems={countItems} page={page} handleChangePage={(newPage: number) => {
                    setPage(newPage)
                    history.push({
                        pathname: location.pathname,
                        search: `?page_num=${newPage}`
                    })
                }}/></div>
        </React.Fragment>
    )
}

export default TeachersList